import { Apis, Enums, Helpers, Store } from "utils";

export interface IQioskService {
  scan(eventId: string): Promise<any>;
  exist(): Promise<any>;
  checkin(id: number): Promise<any>;
}

export class QioskService implements IQioskService {
  private qubehub: any;

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  /**
   * perform the scan of the QRCode at the clinic
   * @param {string} eventId id store in Google Calendar API
   */

  async scan(eventId: string) {
    try {
      return this.#handleResponse(await this.qubehub.post("patient/scan", { eventId }));
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * check if there is any scan for the patient
   */

  async exist() {
    try {
      return this.#handleResponse(await this.qubehub.get("patient/scan"));
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * perform patient's check in at the clinic
   * @param {string} id appointment id
   */

  async checkin(id: number) {
    try {
      return this.#handleResponse(await this.qubehub.get(Helpers.interpolateURL("appointment/checkin/:appointmentId", { appointmentId: id })));
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * method to handle the response from the API
   * @param {any} response the data retrieved from the API
   * @returns
   */

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}

export default QioskService;
